<template>
  <section id="categories" class="pt-16 bg-gascon-gray">
    <div class="container mx-auto px-4">
      <!-- Category badges -->
      <div class="flex flex-wrap justify-center gap-4 mb-12">
        <span
          v-for="category in categories"
          :key="category"
          class="border-2 border-gascon-blue text-gascon-blue px-6 py-2 rounded-full font-medium hover:bg-gascon-blue hover:text-white transition-colors cursor-default"
        >
          {{ category }}
        </span>
      </div>

      <!-- Description text -->
      <div class="max-w-3xl mx-auto text-center">
        <p class="text-gascon-blue leading-relaxed mb-4">
          Chaque jour, avant même que la ville ne se réveille, Le Comptoir Gascon est déjà en route.
        </p>
        <p class="text-gascon-blue leading-relaxed mb-4">
          10 ans à épauler les restaurants bordelais avec des produits triés,
          des prix maîtrisés et une disponibilité qui ne faiblit jamais.
        </p>
        <p class="text-gascon-blue leading-relaxed mb-4">
          Un coup de fil, et l'équipe répond. Toujours là, toujours prête, toujours efficace.
        </p>
        <p class="text-gascon-blue leading-relaxed font-medium">
          Ici, on ne parle pas : on livre.
        </p>
        <p class="text-gascon-blue leading-relaxed mt-6 font-bold">
          Le plan d'attaque : le bon produit, au bon moment, au bon prix.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CategoriesSection',
  data() {
    return {
      categories: [
        'VIANDES',
        'VOLAILLES',
        'CHARCUTERIES ESPAGNOLES ET ITALIENNES',
        'PRODUITS ESPAGNOLS ET ITALIENS',
        'CRÈMERIE ET BURRATA'
      ]
    }
  }
}
</script>
